<template>
  <div id="container">
    <MenuLeft ref="menu" class="left" />
    <PrivacyPolicyDialog v-if="showPrivacy" />
      <router-view></router-view>
    <MenuRight ref="menuright" class="right" />
  </div>
</template>

<script>
import MenuLeft from './MenuLeft'
import MenuRight from './MenuRight'
import PrivacyPolicyDialog from '@/views/service/PrivacyPolicyDialog'
import { mapGetters } from 'vuex'

export default {
  name: 'Full',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['leftMenuOpen', 'showPrivacy'])
  },
  watch: {
    leftMenuOpen (newVal, oldVal) {
      var el = this.$el
      if (newVal) {
        el.classList.add('left-menu-open')
      } else {
        el.classList.remove('left-menu-open')
      }
    }
  },
  components: {
    MenuLeft,
    MenuRight,
    PrivacyPolicyDialog
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Layout.vue